// extracted by mini-css-extract-plugin
export var closeButton = "_d2-1";
export var closeX = "_d2-3";
export var container = "_d2-0";
export var image = "_d2-2";